import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    FiArrowUpCircle,
    FiMoreHorizontal,
    FiRepeat,
    FiUserPlus,
    FiUsers,
    FiUserCheck,
    FiUser,
} from "react-icons/fi";

import { FaWallet } from "react-icons/fa";

import { Container } from "react-bootstrap";

import {
    getDashboardSummary,
    getProfile,
} from "../../store/slices/profile";


const DashboardHome = () => {

    const dispatch = useDispatch();


    /* ================= PROFILE ================= */

    const {
        profilelist,
        dashboardSummary,
        loading,
    } = useSelector(
        (state) => state.profile
    );


    /* ================= PROFILE DATA ================= */

    const profileData =
        profilelist || {};

    const name =
        profileData?.name || "User";

    const userId =
        profileData?.userId || "User";


    /* ================= CALL API ================= */

    useEffect(() => {

        dispatch(
            getDashboardSummary()
        );

        dispatch(
            getProfile()
        );

    }, [dispatch]);


    /* ================= SUMMARY DATA ================= */

    const summaryData =
        dashboardSummary?.data ||
        dashboardSummary ||
        {};


    /* ================= GREETING ================= */

    const getGreeting = () => {

        const hour =
            new Date().getHours();

        if (hour < 12) {
            return "Good morning";
        }

        if (hour < 17) {
            return "Good afternoon";
        }

        return "Good evening";
    };


    const greeting =
        getGreeting();


    /* ================= STATUS ================= */

    const status =
        profileData?.status ||
        "PENDING";


    /* ================= STATS ================= */

    const stats = [

        {
            label: "Total Withdraw",
            value:
                summaryData?.totalWithdraw ?? 0,
            Icon: FiArrowUpCircle,
            tone: "coral",
        },

        {
            label: "Auto Pool Income",
            value:
                summaryData?.autoPoolIncome ?? 0,
            Icon: FiRepeat,
            tone: "mint",
        },

        {
            label: "Referral Income",
            value:
                summaryData?.referralIncome ?? 0,
            Icon: FiUserPlus,
            tone: "gold",
        },

        {
            label: "Current Balance",
            value:
                summaryData?.currentBalance ?? 0,
            Icon: FaWallet,
            tone: "blue",
        },

    ];


    /* ================= TEAM DETAILS ================= */

    const teamDetails = [

        {
            label: "Total Team",
            value:
                summaryData?.totalTeam ?? 0,
            Icon: FiUsers,
            tone: "purple",
        },

        {
            label: "Active Team",
            value:
                summaryData?.activeTeam ?? 0,
            Icon: FiUserCheck,
            tone: "green",
        },

        {
            label: "Total Direct",
            value:
                summaryData?.totalDirect ?? 0,
            Icon: FiUserPlus,
            tone: "orange",
        },

        {
            label: "Active Direct",
            value:
                summaryData?.activeDirect ?? 0,
            Icon: FiUser,
            tone: "blue",
        },

    ];


    return (

        <Container
            fluid
            className="gi-home-dashboard"
        >

            {/* =================================================
                WELCOME
            ================================================= */}

            <section className="gi-welcome-banner">

                <div>

                    <span className="gi-eyebrow">
                        GLOBAL INAVATION
                    </span>

                    <h1>
                        {greeting}, {name} ({userId})!
                    </h1>

                </div>


                <div className="gi-profile-status">

                    <span className="gi-profile-status-label">
                        Profile Status
                    </span>


                    <span
                        className={`gi-status-badge gi-status-${String(
                            status
                        ).toLowerCase()}`}
                    >

                        <span className="gi-status-dot"></span>

                        {status}

                    </span>

                </div>

            </section>


            {/* =================================================
                FINANCIAL STATS
            ================================================= */}

            <section className="gi-stats-grid">

                {stats.map(
                    ({
                        label,
                        value,
                        Icon,
                        tone,
                    }) => (

                        <article
                            className={`gi-stat-card gi-stat-${tone}`}
                            key={label}
                        >

                            {/* TOP */}

                            <div className="gi-stat-top">

                                {/* ICON */}

                                <span className="gi-stat-icon">

                                    <Icon
                                        size={34}
                                        strokeWidth={2.2}
                                    />

                                </span>


                                {/* MORE */}

                                <button
                                    type="button"
                                    className="gi-card-more"
                                    aria-label={`More ${label} options`}
                                >

                                    <FiMoreHorizontal />

                                </button>

                            </div>


                            {/* LABEL */}

                            <span className="gi-stat-label">
                                {label}
                            </span>


                            {/* VALUE */}

                            <strong className="gi-stat-value">

                                {loading
                                    ? "..."
                                    : value
                                }

                            </strong>

                        </article>

                    )
                )}

            </section>

            <section className="gi-team-section mb-5">

                <div className="gi-team-header">

                    <div>
                        <span className="gi-eyebrow">
                            TEAM OVERVIEW
                        </span>

                        <h2>
                            My Team
                        </h2>
                    </div>

                </div>


                <div className="gi-team-cards">

                    {teamDetails.map(
                        ({
                            label,
                            value,
                            Icon,
                            tone,
                        }) => (

                            <article
                                className={`gi-team-card gi-stat-${tone}`}
                                key={label}
                            >

                                <div className="gi-team-card-icon">

                                    <Icon
                                        size={22}
                                        strokeWidth={2.2}
                                    />

                                </div>

                                <div className="gi-team-card-content">

                                    <span className="gi-team-card-label">
                                        {label}
                                    </span>

                                    <strong className="gi-team-card-value">

                                        {loading
                                            ? "..."
                                            : value
                                        }

                                    </strong>

                                </div>

                            </article>

                        )
                    )}

                </div>

            </section>

        </Container>

    );

};


export default DashboardHome;